<template>
  <div class="user-address">
    <span v-if="address.company_name">{{ address.company_name }}</span>
    <span v-if="address.first_name && address.last_name">
      {{ address.first_name }} {{ address.last_name }}
    </span>
    <span>{{ address.address }}</span>
    <span v-if="address.address2">{{ address.address2 }}</span>
    <span>{{ address.city }}, {{ address.state }} {{ address.zip }}</span>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>
.user-address {
  text-align: left;
}
.user-address span {
  display: block;
  margin: 0;
}
</style>
